'use strict';
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import { AuthProvider } from 'react-check-auth';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';

import hpcmp_logo from './static/HPCMP_Red&Black.png';
import oidc_logo from './static/Openid_connect_logo_small.png';
import './App.css';
/* The USWDS has a banner component, so to lessen confusion our 
   Notice and Consent Banner will be locally referred to as the ConsentNotice */
import ConsentNotice from './Banner';
import Landing from './Landing';
import StateMachine from './StateMachine';
import HomeButton from './HomeButton';
import LoginButton from './LoginButton';

/* We are currently using USWDS v1 */
import 'uswds/dist/css/uswds.min.css'
require('uswds')

const cookies = new Cookies();

class App extends Component {
  constructor(props) {
    super(props);
    /* If no cookies then need harmless defaults */
    this.state = {
        got_consent: cookies.get('banner') || false,
        page_opts: cookies.get('oidc-authentication-ui') || 
          { "bannerText": 'An official website of the United States government',
            "bannerColor": 'black',
            "linksEnabled": true,
            "primaryHelpText": 'Contact HPC Help Desk',
            "primaryHelpLink": 'mailto:help@helpdesk.hpc.mil',
            "secondaryHelpText": 'HPC Centers Home Page',
            "secondaryHelpLink": 'https://centers.hpc.mil'
          }
    };
  }

  render() {
    var body = (
      <Switch>
        <Route exact path="/" component={Landing} />
        <Route exact path="/dashboard" component={() => <StateMachine step="dashboard" />} />
        <Route path="/authentication" component={() => <Redirect to="/login" />} />
        <Route path="/login" component={() => <StateMachine step="login" />} />
        <Route path="/logout" component={() => <StateMachine step="logout" />} />
        <Route path="/" component={() => <StateMachine step="login" />} />
      </Switch>);

    var consent = <ConsentNotice onAccept={() => this.accept_consent()} />;

    const disabledLink = {
      pointerEvents: 'none',
      cursor: 'default',
      color: 'black'
    };

    const enabledLink = {
      /* color: 'red' */
    };

    var togA = (
      this.state.page_opts["linksEnabled"] ? enabledLink : disabledLink
    );

    var help_primary = (
      <p>
        <a style={ togA } href={ this.state.page_opts["primaryHelpLink"] }>
          { this.state.page_opts["primaryHelpText"] }
        </a>
      </p>
    );

    var help_secondary = (
      <p>
        <a style={ togA } href={ this.state.page_opts["secondaryHelpLink"] }>
          { this.state.page_opts["secondaryHelpText"] }
        </a>
      </p>
    );

    var filler = ( <div></div> );

    var page_banner_style = {
        color: "white", 
        backgroundColor: this.state.page_opts["bannerColor"],
        textAlign: "center"
    };

    var page_banner_top = (
        <section className="usa-banner">
          <p style={page_banner_style}>
            { this.state.page_opts["bannerText"] }
          </p>
        </section>
    );

    var page_banner_bottom = (
        <section className="usa-banner">
          <p style={page_banner_style}>
            { this.state.page_opts["bannerText"] }
          </p>
        </section>
    );

    return (
      <AuthProvider authUrl={'/user'}>
        <Router>
          <div className="Page">
            { this.state.page_opts["bannerText"] ? page_banner_top : filler }

            <div className="App">
                <a className="usa-skipnav" href="#main-content">Skip to main content</a>
              <div className="usa-grid">

                <header className="App-header usa-header usa-header-basic">
                  <img src={hpcmp_logo} className="App-logo" alt="HPCMP logo" />
                  <img src={oidc_logo} className="App-logo" alt="OpenID logo" />
                </header>

                <main id="main-content">
                  {this.state.got_consent ? body : consent}
                </main>

                <footer className="usa-footer usa-footer-slim" role="contentinfo">
                  <div className="usa-grid usa-footer-return-to-top">
                    <a href="#top">Return to top</a>
                  </div>
                  <div className="usa-footer-primary-section App-footer">
                    <div className="usa-grid">
                      <nav className="usa-footer-nav">
                        <div className="usa-width-one-fourth">
                          <div className="footer-button">
                            <HomeButton className="usa-button-secondary"/>
                          </div>
                        </div>
                        <div className="usa-width-one-fourth">
                          <div className="footer-button">
                            <LoginButton className="usa-button-secondary"/>
                          </div>
                        </div>
                      </nav>
                      <address>
                        <div className="usa-width-one-half">
                          <div className="usa-footer-primary-content usa-footer-contact-info">
                            {help_primary}
                          </div>
                          <div className="usa-footer-secondary-content usa-footer-contact-info">
                            {help_secondary}
                          </div>
                        </div>
                      </address>
                    </div>
                  </div>
                </footer>

              </div>
            </div>

            { this.state.page_opts["bannerText"] ? page_banner_bottom : filler }
          </div>
        </Router>
      </AuthProvider>
    );
  }

  accept_consent() {
    cookies.set('banner', true, { maxAge: 3600*24*7 }, { sameSite: 'none' }, { secure: true });
    this.setState({
      got_consent: true
    });
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js